import React, { useState } from "react";

const data = {
  name: "Alima ",
  role: "Full Stack & AI Engineer",
  tagline: "Integrating Intelligence into Modern Web Systems",
  about: "Bridging the gap between scalable web architecture and cutting-edge Artificial Intelligence. I build autonomous agents, RAG systems, and high-performance full-stack applications.",
  stats: [
    { num: "3+", label: "Years Exp." },
    { num: "25+", label: "Projects" },
    { num: "10+", label: "AI Models" },
  ],
  skills: [
    { category: "AI & Data", tags: ["LangChain", "PyTorch", "OpenAI", "RAG", "Vector DBs"] },
    { category: "Frontend", tags: ["Next.js 15", "React 19", "Three.js", "Tailwind"] },
    { category: "Backend", tags: ["Python", "Node.js", "Go", "PostgreSQL", "Docker"] },
  ],
  
  projects: [
    {
      name: "smartclinic",
      type: "Healthcare SaaS",
        desc: "Enterprise-grade SaaS platform with integrated AI predictive analytics for user retention.",
      stack: ["reactjs", "nodejs","Tailwind"],
      color: "#8B5CF6",
       link: "https://smart-clinic-website.vercel.app/",
    image: "smartclinic.png",
    
    },
    {
      name: "Visionary Dashboard",
      type: "Computer Vision",
      desc: "Real-time object detection system with a low-latency web interface for industrial safety.",
      stack: ["OpenCV", "TensorFlow", "React"],
      color: "#EC4899"
    },
    {
      name: "E-shop",
      type: "Full Stack",
        desc: "A full-featured e-commerce platform with payment integration, admin dashboard, and real-time order tracking.",
      stack: ["react.js", "Tailwind","nodejs", "express","mongodb","stripe"],
      color: "#3B82F6",
       link: "https://eshop-mauve-two.vercel.app/",
    image: "e-shop.png"
    }
  ],
 
  contact: [
    { icon: "✉", val: "sl.alima@gmail.com" },
    { icon: "github", val: "https://github.com/Dev-WIA" },
    { icon: "📍", val: "Algeria" }
  ]
};

export default function Portfolio() {
  const [activeTab, setActiveTab] = useState("about");
  const [isDark, setIsDark] = useState(true);

  const theme = {
    bg: isDark ? "#050505" : "#F8FAFC",
    card: isDark ? "rgba(255, 255, 255, 0.03)" : "rgba(255, 255, 255, 0.8)",
    text: isDark ? "#FFFFFF" : "#0F172A",
    subText: isDark ? "#94A3B8" : "#64748B",
    accent: "#8B5CF6",
    glass: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(15, 23, 42, 0.05)",
    border: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(15, 23, 42, 0.1)",
  };

  return (
    <div style={{ ...styles.container, backgroundColor: theme.bg, color: theme.text }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;800&display=swap');
        * { box-sizing: border-box; font-family: 'Inter', sans-serif; transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
        .bento-card:hover { transform: translateY(-5px); border-color: ${theme.accent}; box-shadow: 0 10px 30px -10px ${theme.accent}44; }
        @media (max-width: 768px) { .sidebar { display: none !important; } .main-grid { grid-template-columns: 1fr !important; padding: 20px !important; } .mobile-nav { display: flex !important; } }
      `}</style>

      {/* Sidebar - Navigation */}
      <aside className="sidebar" style={{ ...styles.sidebar, backgroundColor: theme.card, borderRight: `1px solid ${theme.border}` }}>
        <div style={styles.brand}>
          <div style={{ ...styles.logo, background: `linear-gradient(135deg, ${theme.accent}, #EC4899)` }}>A</div>
          <h2 style={{ fontSize: "1.2rem", fontWeight: "800" }}>Alima.WIA</h2>
        </div>
        
        <nav style={styles.nav}>
          {["about", "expertise", "projects", "contact"].map((item) => (
            <button key={item} onClick={() => setActiveTab(item)} style={{ 
              ...styles.navLink, 
              color: activeTab === item ? theme.accent : theme.subText,
              background: activeTab === item ? theme.glass : "transparent"
            }}>
              {item.charAt(0).toUpperCase() + item.slice(1)}
            </button>
          ))}
        </nav>

        <button onClick={() => setIsDark(!isDark)} style={{ ...styles.toggleTheme, border: `1px solid ${theme.border}` }}>
          {isDark ? "☀️ Light" : "🌙 Dark"}
        </button>
      </aside>

      {/* Main Content Grid */}
      <main className="main-grid" style={styles.mainGrid}>
        
        {/* Header Hero */}
        <header className="bento-card" style={{ ...styles.heroCard, gridColumn: "span 2", backgroundColor: theme.card, border: `1px solid ${theme.border}` }}>
          <span style={{ color: theme.accent, fontWeight: "600", fontSize: "0.9rem" }}>Available for 2026 Opportunities</span>
          <h1 style={styles.h1}>Expert in Full Stack <br/> & <span style={{ color: theme.accent }}>AI Systems</span></h1>
          <p style={{ color: theme.subText, maxWidth: "500px", lineHeight: "1.6" }}>{data.about}</p>
          
          <div style={styles.statsRow}>
            {data.stats.map((s, i) => (
              <div key={i} style={styles.statItem}>
                <span style={{ fontSize: "1.5rem", fontWeight: "800" }}>{s.num}</span>
                <span style={{ fontSize: "0.7rem", color: theme.subText, textTransform: "uppercase" }}>{s.label}</span>
              </div>
            ))}
          </div>
        </header>

        {/* Dynamic Section Rendering */}
        {activeTab === "about" || activeTab === "expertise" ? (
          <>
            {data.skills.map((skill, i) => (
              <section key={i} className="bento-card" style={{ ...styles.card, backgroundColor: theme.card, border: `1px solid ${theme.border}` }}>
                <h3 style={{ marginBottom: "15px", fontSize: "1rem", color: theme.accent }}>{skill.category}</h3>
                <div style={styles.tagWrap}>
                  {skill.tags.map(t => <span key={t} style={{ ...styles.tag, backgroundColor: theme.glass }}>{t}</span>)}
                </div>
              </section>
            ))}
          </>
        ) : null}

       {activeTab === "projects" && (
  <div style={{ display: "contents" }}>
    {data.projects.map((p, i) => (
      <div
        key={i}
        className="bento-card"
        style={{
          ...styles.card,
          backgroundColor: theme.card,
          border: `1px solid ${theme.border}`,
          gridColumn: i === 0 ? "span 2" : "span 1",
        }}
      >
        {/* IMAGE */}
        <img
          src={p.image}
          alt={p.name}
          style={{
            width: "100%",
            height: "180px",
            objectFit: "cover",
            borderRadius: "15px",
            marginBottom: "15px",
          }}
        />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 style={{ fontWeight: "700" }}>{p.name}</h3>
          <span
            style={{
              fontSize: "0.7rem",
              padding: "2px 8px",
              borderRadius: "20px",
              border: `1px solid ${p.color}`,
              color: p.color,
            }}
          >
            {p.type}
          </span>
        </div>

        <p style={{ color: theme.subText, fontSize: "0.85rem", margin: "15px 0" }}>
          {p.desc}
        </p>

        <div style={styles.tagWrap}>
          {p.stack.map((s) => (
            <small key={s} style={{ color: theme.subText }}>
              #{s}
            </small>
          ))}
        </div>

        {/* LINK BUTTON */}
        {p.link && (
          <a
            href={p.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "15px",
              padding: "10px 15px",
              borderRadius: "10px",
              backgroundColor: p.color,
              color: "#fff",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            View Project →
          </a>
        )}
      </div>
    ))}
  </div>
)}

        {activeTab === "contact" && (
          <section className="bento-card" style={{ ...styles.card, gridColumn: "span 2", backgroundColor: theme.card, border: `1px solid ${theme.border}`, textAlign: "center" }}>
            <h2 style={{ marginBottom: "20px" }}>Let's Build the Future</h2>
            <div style={styles.contactRow}>
              {data.contact.map((c, i) => (
                <div key={i} style={{ padding: "20px", background: theme.glass, borderRadius: "15px", flex: 1 }}>
                  <div style={{ fontWeight: "800", color: theme.accent }}>{c.icon}</div>
                  <div style={{ fontSize: "0.9rem", marginTop: "5px" }}>{c.val}</div>
                </div>
              ))}
            </div>
          </section>
        )}
      </main>

      {/* Mobile Nav */}
      <nav className="mobile-nav" style={{ ...styles.mobileNav, backgroundColor: theme.card, borderTop: `1px solid ${theme.border}` }}>
        {["about", "projects", "contact"].map(item => (
          <button key={item} onClick={() => setActiveTab(item)} style={{ ...styles.mobBtn, color: activeTab === item ? theme.accent : theme.subText }}>
            {item === "about" ? "👤" : item === "projects" ? "💼" : "📞"}
            <span style={{ fontSize: "0.6rem" }}>{item.toUpperCase()}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

const styles = {
  container: { display: "flex", minHeight: "100vh", width: "100%" },
  sidebar: { width: "240px", padding: "40px 20px", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh" },
  brand: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "50px" },
  logo: { width: "35px", height: "35px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "bold" },
  nav: { display: "flex", flexDirection: "column", gap: "10px", flex: 1 },
  navLink: { border: "none", padding: "12px 15px", borderRadius: "12px", cursor: "pointer", textAlign: "left", fontSize: "0.9rem", fontWeight: "600" },
  toggleTheme: { padding: "10px", borderRadius: "10px", cursor: "pointer", background: "transparent", color: "inherit", fontWeight: "600" },
  mainGrid: { flex: 1, display: "grid", gridTemplateColumns: "1fr 1fr", gridAutoRows: "min-content", gap: "20px", padding: "60px", maxWidth: "1200px", margin: "0 auto" },
  heroCard: { padding: "50px", borderRadius: "30px", display: "flex", flexDirection: "column", gap: "15px" },
  h1: { fontSize: "3rem", fontWeight: "800", lineHeight: "1.1", margin: 0 },
  statsRow: { display: "flex", gap: "30px", marginTop: "30px" },
  statItem: { display: "flex", flexDirection: "column" },
  card: { padding: "30px", borderRadius: "25px" },
  tagWrap: { display: "flex", flexWrap: "wrap", gap: "8px" },
  tag: { padding: "5px 12px", borderRadius: "8px", fontSize: "0.75rem", fontWeight: "600" },
  contactRow: { display: "flex", gap: "15px", flexWrap: "wrap" },
  mobileNav: { display: "none", position: "fixed", bottom: 0, left: 0, right: 0, height: "70px", justifyContent: "space-around", alignItems: "center", paddingBottom: "10px", zIndex: 1000 },
  mobBtn: { background: "none", border: "none", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }
}; 